import {BlockContainer} from "BaseComponents/Wrappers";
import React, {useState, useRef, useEffect} from "react";
import {H2, H3, Paragraph} from "BaseComponents/Text";
import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import {PrimaryButton, ButtonText} from "Buttons";
import {useGlobal} from "reactn";
import {GetTextColor} from "Helpers/ColorHelper";

export const LinkListElement = ({Heading, Links, BackgroundColor}) => {
    const [theme] = useGlobal("theme");
    const {textColor} = GetTextColor(BackgroundColor);
    return (
        <BlockContainer bgColor={`#${BackgroundColor ? BackgroundColor : "fff"}`}>
            <LinkBlock>
                <H2 color={textColor} align="center">
                    {Heading}
                </H2>

                <LinkListWrapper>
                    {Links.map((link, i) => {
                        const {Name, Type, Url, Target} = link;
                        let hasTarget = Target === "_blank";
                        let fileExtension = Type == 1 ? Url.split('.').pop().replace('#', '') : "";
                        let isWordFile = fileExtension == "docx" || fileExtension == "doc";
                        const isPdf = fileExtension == "pdf";

                        return (
                            <ButtonWrapper key={`link-list-${i}`}>
                                <PrimaryButton
                                    className={textColor === "#fff" ? '': 'inverted'}
                                    forcedColor={textColor}
                                    download={Type == 1 && !hasTarget}
                                    target={Target}
                                    widthsmall="160px"
                                    href={Url}
                                    margin="15px 0 15px 15px"
                                    minHeightSmall="45px"
                                    minHeight="40px"
                                    smallmargin="5px 1rem"
                                    wide
                                    widthsmall="100%"
                                >

                                    {Type == 1 && isWordFile ? (
                                            <IconBefore className="fa-regular fa-file-word"></IconBefore>
                                        ) :
                                        Type == 1 && isPdf ? (
                                                <IconBefore className="fa-regular fa-file-pdf"></IconBefore>
                                            ) :
                                            Type == 1 ? (
                                                <IconBefore className="fa-regular fa-file"></IconBefore>
                                            ) : null}

                                    <ButtonText heading={Heading}>
                                        {Name}
                                    </ButtonText>

                                    {Type == 1 && !hasTarget ? (
                                            <IconAfter className="fa-regular fa-download"></IconAfter>
                                        ) :
                                        Type == 1 && hasTarget ? (
                                                <IconAfter className="fa-regular fa-external-link"></IconAfter>
                                            ) :
                                            Type == 2 ? (
                                                <IconAfter className="fa-regular fa-external-link"></IconAfter>
                                            ) : null}

                                </PrimaryButton>
                            </ButtonWrapper>
                        );
                    })}
                </LinkListWrapper>
            </LinkBlock>
        </BlockContainer>
    );
};

const ButtonWrapper = styled.div`
    margin-left: 15px;
    flex-grow: 1;
    width: auto;
    max-width: calc(33.33333333% - 15px);
    flex-basis: calc(33.3333333% - 15px);
    ${media.lessThan(breakpoints.mobile)`
	margin-left: 0;
		max-width: unset;
		flex-basis: unset;
		width: 100%;


`}
`;
export const IconBefore = styled.i`
    position: absolute;
    left: 0;
    padding-left: 1rem;
    ${media.lessThan(breakpoints.mobile)`
  padding-left: 3rem;

  `}
`;
export const IconAfter = styled.i`
    position: absolute;
    right: 0;
    padding-right: 1rem;
`;
export const LinkBlock = styled.div`
    padding: 0 1rem;
    margin: 0 auto;
    max-width: 1280px;

    ${media.lessThan(breakpoints.ipad)`
  padding: 1rem 1rem;
  
  `}
    ${media.lessThan(breakpoints.mobile)`
  padding: 0 1rem;

  `}
`;
export const LinkListWrapper = styled.div`
    a[href$=".pdf"]:before {
        display: none;
    }

    a[href$=".doc"]:before {
        display: none;
    }

    a[href$=".docx"]:before {
        display: none;
    }

    ${media.greaterThan(breakpoints.mobile)`
    margin-top: 30px;
  `}
    transition: 0.3s ease;
    flex-wrap: wrap;
    display: flex;
    height: 100%;
    width: 100%;
    max-width: ${({width}) => (width ? width : "")};
    align-items: center;
    transition-delay: 0.2s;
    margin-bottom: 25px;
    flex-wrap: wrap;
    margin: 0 0 0 -15px;
    display: flex;
    ${media.lessThan(breakpoints.mobile)`
	flex-direction: column;
	
	`}
    background-color: ${({bgColor}) => (bgColor ? bgColor : "transparent")};

    ${PrimaryButton} {
        flex-grow: 1;
        width: auto;
        ${media.lessThan(breakpoints.mobile)`
		width: 100%;


`}
    }
`;
